// src/pages/ProductDetail.js
import React from "react";
import { useParams } from "react-router-dom";
import { Box, Heading, Text, Image, Button, VStack, Flex } from "@chakra-ui/react";
import { useProducts } from "./ProductContext";
import { Link as RouterLink } from "react-router-dom";

const ProductDetail = () => {
  const { id } = useParams();
  const { products/* , addToCart */ } = useProducts();

  // Finn produktet basert på ID-en fra URL
  const product = products.find((p) => p.id === parseInt(id));

  // Hvis produktet ikke finnes (f.eks. feil URL)
  if (!product) {
    return (
      <Box p={{ base: 2, md: 8 }}>
        <Heading as="h2" size={{ base: "md", md: "lg" }}>
          Produkt ikke funnet
        </Heading>
      </Box>
    );
  }

  // Eksempel med flere bilder:
  // Du kan lagre en array av bilder i product, f.eks. product.images,
  // og vise dem her i et galleri om du ønsker.

  /* const handleAddToCart = () => {
    addToCart(product);
  }; */

  return (
    <Box p={{ base: 2, md: 8 }}>
      <RouterLink to="/portfolio">
        <Button
          variant="outline"
          colorScheme="teal"
          mb={4}
          fontSize={{ base: "md", md: "lg" }}
          py={{ base: 3, md: 4 }}
          px={{ base: 4, md: 6 }}
          minH="44px"
          width={{ base: "100%", md: "auto" }}
        >
          ← Tilbake til produkter
        </Button>
      </RouterLink>
      <Flex flexDirection={{ base: "column", md: "row" }} gap={{ base: 4, md: 8 }}>
        <Box flex="1" mb={{ base: 4, md: 0 }}>
          <Image
            src={product.imageUrl}
            alt={product.name}
            borderRadius="md"
            objectFit="cover"
            maxW="100%"
            maxH={{ base: "300px", md: "500px" }}
            mx="auto"
          />
        </Box>
        <VStack flex="1" align="flex-start" spacing={4}>
          <Heading as="h2" size={{ base: "md", md: "lg" }}>{product.name}</Heading>
          <Text color="gray.600" fontSize={{ base: "sm", md: "md" }}>
            {product.description}
          </Text>
          {/* ...evt. flere elementer... */}
        </VStack>
      </Flex>
    </Box>
  );
};

export default ProductDetail;